<template>
  <base-section
    id="features"
    class="primary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card
              align="center"
              dark
              color="#fff"
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          icon: 'mdi-clock-outline',
          title: 'Öffnungszeiten Bar',
          text:
            'Aufgrund der aktuellen Lage können die Öffnungszeiten variieren. Gerne können Sie unseren Abhol- und Bestellservice nutzen oder mit Werkvertrag direkt in unserer CaféBar konsumieren.',
        },
        {
          icon: 'mdi-food-fork-drink',
          title: 'Warme und kalte Küche',
          text:
            'Unsere Küche ist von Montag bis Freitag für Sie geöffnet. Zusätzlich zu warmen Brötchen und Salaten, bieten wir Ihnen immer einen Tagesteller und eine Tagessuppe an.',
        },
        {
          icon: 'mdi-rewind-14',
          title: 'Bestellungen',
          text:
            'Aus organisatorischen Gründen bitten wir Sie Ihre Bestellung innerhalb 14 Uhr zu tätigen. Ab diesem Zeitpunkt kann nur mehr auf Anfrage telefonisch unter 0471 180 7699 bestellt werden.',
        },
        {
          icon: 'mdi-car',
          title: 'Abholen leicht gemacht',
          text:
            'Abholen leicht gemacht! Sie können ganz einfach online bestellen und Ihr Essen direkt aus dem Auto entgegennehmen. Nutzen Sie die Rampe des Kampill Center in den 1. Stock.',
        },
      ],
    }),
  }
</script>
